import c0 from './address_geocode_prefill_controller';
import c1 from './ai_chat_controller';
import c2 from './ama_publish_controller';
import c3 from './amount_toggle_controller';
import c4 from './auto_save_controller';
import c5 from './autolink_controller';
import c6 from './beacon_link_controller';
import c7 from './bridge/beacon_link_controller';
import c8 from './bridge/intercom_controller';
import c9 from './bridge/menu_controller';
import c10 from './bridge/navigation_controller';
import c11 from './character_count_controller';
import c12 from './click_tracker_controller';
import c13 from './confirm_submit_controller';
import c14 from './confirmation_controller';
import c15 from './copy_to_clipboard_controller';
import c16 from './custom_domain_validation_controller';
import c17 from './elapsed_controller';
import c18 from './email_validation_controller';
import c19 from './expandable_content_controller';
import c20 from './extra_support_controller';
import c21 from './feed_item_switcher_controller';
import c22 from './form_controller';
import c23 from './highcharts_controller';
import c24 from './image_preview_controller';
import c25 from './inline_edit_controller';
import c26 from './live_activity_feed_controller';
import c27 from './live_console_controller';
import c28 from './live_poll_dashboard_controller';
import c29 from './live_poll_options_controller';
import c30 from './local_time_controller';
import c31 from './login_code_controller';
import c32 from './login_controller';
import c33 from './new_tab_link_controller';
import c34 from './notification_preferences_controller';
import c35 from './password_validator_controller';
import c36 from './plan_toggle_controller';
import c37 from './plan_unwrap_controller';
import c38 from './play_controls_controller';
import c39 from './playlist_sort_confirm_controller';
import c40 from './post_episode_picker_controller';
import c41 from './preview_controller';
import c42 from './preview_target_controller';
import c43 from './promotion_order_controller';
import c44 from './purchase_checkout_controller';
import c45 from './range_selector_controller';
import c46 from './search_filter_controller';
import c47 from './search_toggle_controller';
import c48 from './settings_search_controller';
import c49 from './share_link_controller';
import c50 from './sortable_list_controller';
import c51 from './status_page_controller';
import c52 from './stripe_confirm_controller';
import c53 from './stripe_payment_controller';
import c54 from './switch_subdomain_controller';
import c55 from './tabs_controller';
import c56 from './tiptap_controller';
import c57 from './tom_select_controller';
import c58 from './trix_default_message_controller';
import c59 from './trix_no_attachments_controller';
import c60 from './trix_restricted_toolbar_controller';
import c61 from './trix_upload_controller';
import c62 from './typed_confirmation_controller';
import c63 from './visibility_toggle_controller';
import c64 from './welcome_message_controller';
export const definitions = [
	{identifier: 'address-geocode-prefill', controllerConstructor: c0},
	{identifier: 'ai-chat', controllerConstructor: c1},
	{identifier: 'ama-publish', controllerConstructor: c2},
	{identifier: 'amount-toggle', controllerConstructor: c3},
	{identifier: 'auto-save', controllerConstructor: c4},
	{identifier: 'autolink', controllerConstructor: c5},
	{identifier: 'beacon-link', controllerConstructor: c6},
	{identifier: 'bridge--beacon-link', controllerConstructor: c7},
	{identifier: 'bridge--intercom', controllerConstructor: c8},
	{identifier: 'bridge--menu', controllerConstructor: c9},
	{identifier: 'bridge--navigation', controllerConstructor: c10},
	{identifier: 'character-count', controllerConstructor: c11},
	{identifier: 'click-tracker', controllerConstructor: c12},
	{identifier: 'confirm-submit', controllerConstructor: c13},
	{identifier: 'confirmation', controllerConstructor: c14},
	{identifier: 'copy-to-clipboard', controllerConstructor: c15},
	{identifier: 'custom-domain-validation', controllerConstructor: c16},
	{identifier: 'elapsed', controllerConstructor: c17},
	{identifier: 'email-validation', controllerConstructor: c18},
	{identifier: 'expandable-content', controllerConstructor: c19},
	{identifier: 'extra-support', controllerConstructor: c20},
	{identifier: 'feed-item-switcher', controllerConstructor: c21},
	{identifier: 'form', controllerConstructor: c22},
	{identifier: 'highcharts', controllerConstructor: c23},
	{identifier: 'image-preview', controllerConstructor: c24},
	{identifier: 'inline-edit', controllerConstructor: c25},
	{identifier: 'live-activity-feed', controllerConstructor: c26},
	{identifier: 'live-console', controllerConstructor: c27},
	{identifier: 'live-poll-dashboard', controllerConstructor: c28},
	{identifier: 'live-poll-options', controllerConstructor: c29},
	{identifier: 'local-time', controllerConstructor: c30},
	{identifier: 'login-code', controllerConstructor: c31},
	{identifier: 'login', controllerConstructor: c32},
	{identifier: 'new-tab-link', controllerConstructor: c33},
	{identifier: 'notification-preferences', controllerConstructor: c34},
	{identifier: 'password-validator', controllerConstructor: c35},
	{identifier: 'plan-toggle', controllerConstructor: c36},
	{identifier: 'plan-unwrap', controllerConstructor: c37},
	{identifier: 'play-controls', controllerConstructor: c38},
	{identifier: 'playlist-sort-confirm', controllerConstructor: c39},
	{identifier: 'post-episode-picker', controllerConstructor: c40},
	{identifier: 'preview', controllerConstructor: c41},
	{identifier: 'preview-target', controllerConstructor: c42},
	{identifier: 'promotion-order', controllerConstructor: c43},
	{identifier: 'purchase-checkout', controllerConstructor: c44},
	{identifier: 'range-selector', controllerConstructor: c45},
	{identifier: 'search-filter', controllerConstructor: c46},
	{identifier: 'search-toggle', controllerConstructor: c47},
	{identifier: 'settings-search', controllerConstructor: c48},
	{identifier: 'share-link', controllerConstructor: c49},
	{identifier: 'sortable-list', controllerConstructor: c50},
	{identifier: 'status-page', controllerConstructor: c51},
	{identifier: 'stripe-confirm', controllerConstructor: c52},
	{identifier: 'stripe-payment', controllerConstructor: c53},
	{identifier: 'switch-subdomain', controllerConstructor: c54},
	{identifier: 'tabs', controllerConstructor: c55},
	{identifier: 'tiptap', controllerConstructor: c56},
	{identifier: 'tom-select', controllerConstructor: c57},
	{identifier: 'trix-default-message', controllerConstructor: c58},
	{identifier: 'trix-no-attachments', controllerConstructor: c59},
	{identifier: 'trix-restricted-toolbar', controllerConstructor: c60},
	{identifier: 'trix-upload', controllerConstructor: c61},
	{identifier: 'typed-confirmation', controllerConstructor: c62},
	{identifier: 'visibility-toggle', controllerConstructor: c63},
	{identifier: 'welcome-message', controllerConstructor: c64},
];
